import { useMutation } from '@tanstack/react-query';

import { fetchSaveUploadedDocuments } from './lendingApiQueries';
import { IwQueryClient } from '../../store/IwQueryClient';

export const useDocumentUploadMutation = () => {
  return useMutation({
    mutationFn: fetchSaveUploadedDocuments,
    onSuccess: () => {
      IwQueryClient.getOrCreate().invalidateQueries({
        queryKey: ['documents'],
      });
    },
  });
};
